import { createNullableContext } from '~/common/contexts/nullableContext';
import { AssetRepositoryContextType } from './types/AssetRepositoryContextType';

export const AssetRepositoryContext =
  createNullableContext<AssetRepositoryContextType>();
